import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* Удаление привязанной карты клиента и списка привязанных карт.
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v1#/Card/c323bbb4efc4c87745c4f02d33e065d7
*/

export const deleteCard = (providerId: number, binding_id: number): IRequest => ({
    uri: `/card/remove?binding_id=${binding_id}`,
    withAuth: true,
    withProvider: true,
    method: 'DELETE',
    queryParams: {
        providerId,
    },
});
